"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Predecessor = exports.Successor = exports.MaxValue = exports.MinValue = exports.Power = exports.Log = exports.Exp = exports.Ln = exports.Round = exports.Negate = exports.Abs = exports.Truncate = exports.Floor = exports.Ceiling = exports.Modulo = exports.TruncatedDivide = exports.Divide = exports.Multiply = exports.Subtract = exports.Add = void 0;
var expression_1 = require("./expression");
var MathUtil = __importStar(require("../util/math"));
var quantity_1 = require("../datatypes/quantity");
var uncertainty_1 = require("../datatypes/uncertainty");
var builder_1 = require("./builder");
var Add = /** @class */ (function (_super) {
    __extends(Add, _super);
    function Add(json) {
        return _super.call(this, json) || this;
    }
    Add.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args == null || args.some(function (x) { return x == null; })) {
            return null;
        }
        var sum = args.reduce(function (x, y) {
            if (x.isUncertainty && !y.isUncertainty) {
                y = new uncertainty_1.Uncertainty(y, y);
            }
            else if (y.isUncertainty && !x.isUncertainty) {
                x = new uncertainty_1.Uncertainty(x, x);
            }
            if (x.isQuantity || x.isDateTime || x.isDate || (x.isTime && x.isTime())) {
                return (0, quantity_1.doAddition)(x, y);
            }
            else if (x.isUncertainty && y.isUncertainty) {
                if (x.low.isQuantity ||
                    x.low.isDateTime ||
                    x.low.isDate ||
                    (x.low.isTime && x.low.isTime())) {
                    return new uncertainty_1.Uncertainty((0, quantity_1.doAddition)(x.low, y.low), (0, quantity_1.doAddition)(x.high, y.high));
                }
                else {
                    return new uncertainty_1.Uncertainty(x.low + y.low, x.high + y.high);
                }
            }
            else {
                return x + y;
            }
        });
        if (MathUtil.overflowsOrUnderflows(sum)) {
            return null;
        }
        return sum;
    };
    return Add;
}(expression_1.Expression));
exports.Add = Add;
var Subtract = /** @class */ (function (_super) {
    __extends(Subtract, _super);
    function Subtract(json) {
        return _super.call(this, json) || this;
    }
    Subtract.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args == null || args.some(function (x) { return x == null; })) {
            return null;
        }
        var difference = args.reduce(function (x, y) {
            if (x.isUncertainty && !y.isUncertainty) {
                y = new uncertainty_1.Uncertainty(y, y);
            }
            else if (y.isUncertainty && !x.isUncertainty) {
                x = new uncertainty_1.Uncertainty(x, x);
            }
            if (x.isQuantity || x.isDateTime || x.isDate) {
                return (0, quantity_1.doSubtraction)(x, y);
            }
            else if (x.isUncertainty && y.isUncertainty) {
                if (x.low.isQuantity || x.low.isDateTime || x.low.isDate) {
                    return new uncertainty_1.Uncertainty((0, quantity_1.doSubtraction)(x.low, y.high), (0, quantity_1.doSubtraction)(x.high, y.low));
                }
                else {
                    return new uncertainty_1.Uncertainty(x.low - y.high, x.high - y.low);
                }
            }
            else {
                return x - y;
            }
        });
        if (MathUtil.overflowsOrUnderflows(difference)) {
            return null;
        }
        return difference;
    };
    return Subtract;
}(expression_1.Expression));
exports.Subtract = Subtract;
var Multiply = /** @class */ (function (_super) {
    __extends(Multiply, _super);
    function Multiply(json) {
        return _super.call(this, json) || this;
    }
    Multiply.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args == null || args.some(function (x) { return x == null; })) {
            return null;
        }
        var product = args.reduce(function (x, y) {
            if (x.isUncertainty && !y.isUncertainty) {
                y = new uncertainty_1.Uncertainty(y, y);
            }
            else if (y.isUncertainty && !x.isUncertainty) {
                x = new uncertainty_1.Uncertainty(x, x);
            }
            if (x.isQuantity || y.isQuantity) {
                return (0, quantity_1.doMultiplication)(x, y);
            }
            else if (x.isUncertainty && y.isUncertainty) {
                if (x.low.isQuantity) {
                    return new uncertainty_1.Uncertainty((0, quantity_1.doMultiplication)(x.low, y.low), (0, quantity_1.doMultiplication)(x.high, y.high));
                }
                else {
                    return new uncertainty_1.Uncertainty(x.low * y.low, x.high * y.high);
                }
            }
            else {
                return x * y;
            }
        });
        if (MathUtil.overflowsOrUnderflows(product)) {
            return null;
        }
        return product;
    };
    return Multiply;
}(expression_1.Expression));
exports.Multiply = Multiply;
var Divide = /** @class */ (function (_super) {
    __extends(Divide, _super);
    function Divide(json) {
        return _super.call(this, json) || this;
    }
    Divide.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args == null || args.some(function (x) { return x == null; })) {
            return null;
        }
        var quotient = args.reduce(function (x, y) {
            if (x.isUncertainty && !y.isUncertainty) {
                y = new uncertainty_1.Uncertainty(y, y);
            }
            else if (y.isUncertainty && !x.isUncertainty) {
                x = new uncertainty_1.Uncertainty(x, x);
            }
            if (x.isQuantity) {
                return (0, quantity_1.doDivision)(x, y);
            }
            else if (x.isUncertainty && y.isUncertainty) {
                if (x.low.isQuantity) {
                    return new uncertainty_1.Uncertainty((0, quantity_1.doDivision)(x.low, y.high), (0, quantity_1.doDivision)(x.high, y.low));
                }
                else {
                    return new uncertainty_1.Uncertainty(x.low / y.high, x.high / y.low);
                }
            }
            else {
                return x / y;
            }
        });
        // Note, anything divided by 0 is Infinity in Javascript, which will be
        // considered as overflow by this check.
        if (MathUtil.overflowsOrUnderflows(quotient)) {
            return null;
        }
        return quotient;
    };
    return Divide;
}(expression_1.Expression));
exports.Divide = Divide;
var TruncatedDivide = /** @class */ (function (_super) {
    __extends(TruncatedDivide, _super);
    function TruncatedDivide(json) {
        return _super.call(this, json) || this;
    }
    TruncatedDivide.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args == null || args.some(function (x) { return x == null; })) {
            return null;
        }
        var quotient = args.reduce(function (x, y) { return x / y; });
        var truncatedQuotient = quotient >= 0 ? Math.floor(quotient) : Math.ceil(quotient);
        if (MathUtil.overflowsOrUnderflows(truncatedQuotient)) {
            return null;
        }
        return truncatedQuotient;
    };
    return TruncatedDivide;
}(expression_1.Expression));
exports.TruncatedDivide = TruncatedDivide;
var Modulo = /** @class */ (function (_super) {
    __extends(Modulo, _super);
    function Modulo(json) {
        return _super.call(this, json) || this;
    }
    Modulo.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args == null || args.some(function (x) { return x == null; })) {
            return null;
        }
        var modulo = args.reduce(function (x, y) { return x % y; });
        return MathUtil.decimalOrNull(modulo);
    };
    return Modulo;
}(expression_1.Expression));
exports.Modulo = Modulo;
var Ceiling = /** @class */ (function (_super) {
    __extends(Ceiling, _super);
    function Ceiling(json) {
        return _super.call(this, json) || this;
    }
    Ceiling.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        return Math.ceil(arg);
    };
    return Ceiling;
}(expression_1.Expression));
exports.Ceiling = Ceiling;
var Floor = /** @class */ (function (_super) {
    __extends(Floor, _super);
    function Floor(json) {
        return _super.call(this, json) || this;
    }
    Floor.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        return Math.floor(arg);
    };
    return Floor;
}(expression_1.Expression));
exports.Floor = Floor;
var Truncate = /** @class */ (function (_super) {
    __extends(Truncate, _super);
    function Truncate(json) {
        return _super.call(this, json) || this;
    }
    Truncate.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        return arg >= 0 ? Math.floor(arg) : Math.ceil(arg);
    };
    return Truncate;
}(expression_1.Expression));
exports.Truncate = Truncate;
var Abs = /** @class */ (function (_super) {
    __extends(Abs, _super);
    function Abs(json) {
        return _super.call(this, json) || this;
    }
    Abs.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        else if (arg.isQuantity) {
            return new quantity_1.Quantity(Math.abs(arg.value), arg.unit);
        }
        else {
            return Math.abs(arg);
        }
    };
    return Abs;
}(expression_1.Expression));
exports.Abs = Abs;
var Negate = /** @class */ (function (_super) {
    __extends(Negate, _super);
    function Negate(json) {
        return _super.call(this, json) || this;
    }
    Negate.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        else if (arg.isQuantity) {
            return new quantity_1.Quantity(arg.value * -1, arg.unit);
        }
        else {
            return arg * -1;
        }
    };
    return Negate;
}(expression_1.Expression));
exports.Negate = Negate;
var Round = /** @class */ (function (_super) {
    __extends(Round, _super);
    function Round(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = (0, builder_1.build)(json.precision);
        return _this;
    }
    Round.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        var dec = this.precision != null ? this.precision.execute(ctx) : 0;
        return Math.round(arg * Math.pow(10, dec)) / Math.pow(10, dec);
    };
    return Round;
}(expression_1.Expression));
exports.Round = Round;
var Ln = /** @class */ (function (_super) {
    __extends(Ln, _super);
    function Ln(json) {
        return _super.call(this, json) || this;
    }
    Ln.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        var ln = Math.log(arg);
        return MathUtil.decimalOrNull(ln);
    };
    return Ln;
}(expression_1.Expression));
exports.Ln = Ln;
var Exp = /** @class */ (function (_super) {
    __extends(Exp, _super);
    function Exp(json) {
        return _super.call(this, json) || this;
    }
    Exp.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        var power = Math.exp(arg);
        if (MathUtil.overflowsOrUnderflows(power)) {
            return null;
        }
        return power;
    };
    return Exp;
}(expression_1.Expression));
exports.Exp = Exp;
var Log = /** @class */ (function (_super) {
    __extends(Log, _super);
    function Log(json) {
        return _super.call(this, json) || this;
    }
    Log.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args == null || args.some(function (x) { return x == null; })) {
            return null;
        }
        var log = args.reduce(function (x, y) { return Math.log(x) / Math.log(y); });
        return MathUtil.decimalOrNull(log);
    };
    return Log;
}(expression_1.Expression));
exports.Log = Log;
var Power = /** @class */ (function (_super) {
    __extends(Power, _super);
    function Power(json) {
        return _super.call(this, json) || this;
    }
    Power.prototype.exec = function (ctx) {
        var args = this.execArgs(ctx);
        if (args == null || args.some(function (x) { return x == null; })) {
            return null;
        }
        var power = args.reduce(function (x, y) { return Math.pow(x, y); });
        if (MathUtil.overflowsOrUnderflows(power)) {
            return null;
        }
        return power;
    };
    return Power;
}(expression_1.Expression));
exports.Power = Power;
var MinValue = /** @class */ (function (_super) {
    __extends(MinValue, _super);
    function MinValue(json) {
        var _this = _super.call(this, json) || this;
        _this.valueType = json.valueType;
        return _this;
    }
    MinValue.prototype.exec = function (ctx) {
        if (MinValue.MIN_VALUES[this.valueType]) {
            if (this.valueType === '{urn:hl7-org:elm-types:r1}DateTime') {
                var minDateTime = MinValue.MIN_VALUES[this.valueType].copy();
                minDateTime.timezoneOffset = ctx.getTimezoneOffset();
                return minDateTime;
            }
            else {
                return MinValue.MIN_VALUES[this.valueType];
            }
        }
        else {
            throw new Error("Minimum not supported for ".concat(this.valueType));
        }
    };
    MinValue.MIN_VALUES = {
        '{urn:hl7-org:elm-types:r1}Integer': MathUtil.MIN_INT_VALUE,
        '{urn:hl7-org:elm-types:r1}Decimal': MathUtil.MIN_FLOAT_VALUE,
        '{urn:hl7-org:elm-types:r1}DateTime': MathUtil.MIN_DATETIME_VALUE,
        '{urn:hl7-org:elm-types:r1}Date': MathUtil.MIN_DATE_VALUE,
        '{urn:hl7-org:elm-types:r1}Time': MathUtil.MIN_TIME_VALUE
    };
    return MinValue;
}(expression_1.Expression));
exports.MinValue = MinValue;
var MaxValue = /** @class */ (function (_super) {
    __extends(MaxValue, _super);
    function MaxValue(json) {
        var _this = _super.call(this, json) || this;
        _this.valueType = json.valueType;
        return _this;
    }
    MaxValue.prototype.exec = function (ctx) {
        if (MaxValue.MAX_VALUES[this.valueType] != null) {
            if (this.valueType === '{urn:hl7-org:elm-types:r1}DateTime') {
                var maxDateTime = MaxValue.MAX_VALUES[this.valueType].copy();
                maxDateTime.timezoneOffset = ctx.getTimezoneOffset();
                return maxDateTime;
            }
            else {
                return MaxValue.MAX_VALUES[this.valueType];
            }
        }
        else {
            throw new Error("Maximum not supported for ".concat(this.valueType));
        }
    };
    MaxValue.MAX_VALUES = {
        '{urn:hl7-org:elm-types:r1}Integer': MathUtil.MAX_INT_VALUE,
        '{urn:hl7-org:elm-types:r1}Decimal': MathUtil.MAX_FLOAT_VALUE,
        '{urn:hl7-org:elm-types:r1}DateTime': MathUtil.MAX_DATETIME_VALUE,
        '{urn:hl7-org:elm-types:r1}Date': MathUtil.MAX_DATE_VALUE,
        '{urn:hl7-org:elm-types:r1}Time': MathUtil.MAX_TIME_VALUE
    };
    return MaxValue;
}(expression_1.Expression));
exports.MaxValue = MaxValue;
var Successor = /** @class */ (function (_super) {
    __extends(Successor, _super);
    function Successor(json) {
        return _super.call(this, json) || this;
    }
    Successor.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        var successor = null;
        try {
            // MathUtil.successor throws on overflow, and the exception is used in
            // the logic for evaluating `meets`, so it can't be changed to just return null
            successor = MathUtil.successor(arg);
        }
        catch (e) {
            if (e instanceof MathUtil.OverFlowException) {
                return null;
            }
        }
        if (MathUtil.overflowsOrUnderflows(successor)) {
            return null;
        }
        return successor;
    };
    return Successor;
}(expression_1.Expression));
exports.Successor = Successor;
var Predecessor = /** @class */ (function (_super) {
    __extends(Predecessor, _super);
    function Predecessor(json) {
        return _super.call(this, json) || this;
    }
    Predecessor.prototype.exec = function (ctx) {
        var arg = this.execArgs(ctx);
        if (arg == null) {
            return null;
        }
        var predecessor = null;
        try {
            // MathUtil.predecessor throws on underflow, and the exception is used in
            // the logic for evaluating `meets`, so it can't be changed to just return null
            predecessor = MathUtil.predecessor(arg);
        }
        catch (e) {
            if (e instanceof MathUtil.OverFlowException) {
                return null;
            }
        }
        if (MathUtil.overflowsOrUnderflows(predecessor)) {
            return null;
        }
        return predecessor;
    };
    return Predecessor;
}(expression_1.Expression));
exports.Predecessor = Predecessor;
//# sourceMappingURL=arithmetic.js.map